export default {
    //获取优惠券
    getConponList: "client/coupon/getUserCoupon",
    //用户地址操作api
    addressApi: "client/receive/operatioin",
    //查找用户地址
    queryAddressListApi: "client/receive/listByType",
    //查找联系人
    queryLinkmanListApi: "client/linkman/list",
    //通过id查找
    queryLinkmanById: "client/linkman/detailById",
    //联系人操作api
    linkmanApi: "client/linkman/operation",
    //用户 发票操作api
    invoiceApi: "client/invoice/operation",
    //查找用户发票列表
    queryInvoiceList: "client/invoice/query/list",
    //通过id查找用户发票
    queryInvoiceById: "client/invoice/query/invoiceId",
    //获取用户中心 用户数据
    getUserInfo: "client/member/user/center",
    //查询订单列表
    order_queryOrderList: "client/order/queryOrderList",
    //查询订单详情
    order_queryOrderDetail: "client/order/queryOrderDetail",
    //用户 上传支付凭证
    uploadPayVoucher: "client/order/file/editOrderFile",
    //用户 订单再次购买商品
    buyAgainProduct: "client/order/repurchase",
    //用户 更新订单 取消 || 确认
    updateOrder: "client/order/updateOrder",
    //用户 退货列表
    getReturnedList: "client/salesReturn/querySalesReturn",
    //用户 退货详情
    getReturnedInfo: "client/salesReturn/querySalesReturnDetail",
    //用户 退货填写物流单号
    fillLogisticsNumber: "client/salesReturn/updateSalesReturnForUpload",
    //用户 取消退货
    cancelReturned: "client/salesReturn/returnCancel",
    //用户 申请退货 退款 商品信息
    getGoodsReturnedInfo: "client/salesReturn/queryOrderForRefund",
    //用户 保存退货申请
    saveReturned: "client/salesReturn/saveSalesReturn",
    //是否美隆用户
    verifyMlUser: "client/member/check/user/isML",
    //查找用户是否包含密码
    queryHasPassword: "client/member/query/password",
    //获取钱包信息
    queryWalletInfo: "client/pc/wallet/getWalletInfo",
    //注册钱包信息
    registerWalletInfo: "client/pc/wallet/generate",
    //钱包充值
    walletRecharge: "client/pc/wallet/rechargeWallet",
    //校验钱包密码
    validateWalletPassword: "client/pc/wallet/checkPassword",
    //钱包提现
    returnWalletCash: "client/pc/wallet/returnWalletCash",
    //重置钱包密码短信
    resetWalletPasswordSms: "client/pc/wallet/sendPasswordResetSms",
    //校验重置密码短信
    validateWalletPasswordSms:
        "client/pc/wallet/checkPasswordResetVerificationCode",
    //更改钱包密码
    updateWalletPassword: "client/pc/wallet/changeWalletPassword",
    //更新钱包绑定公司
    updateWalletCompanyInfo: "client/pc/wallet/changeCompany",
    //查询钱包交易记录
    queryWalletTransaction: "client/pc/wallet/getTradeRecordForPage",
    //查询钱包充值记录
    queryWalletRecharge: "client/pc/wallet/getTradeRecordForPage",
    //查询订单支付钱包余额
    queryOrderWalletBalance: "client/wallet/pay/selectWalletAccountBalance",
    //验证钱包金额限额 每日限额
    vlidateWalletMonetaryLimitation: "client/pc/wallet/checkIsLimitationOrder",
    //修改钱包信用额度
    updateWalletCredit: "client/pc/wallet/changeWalletInfoSetting",
    //发送钱包
    sendWalletCreditUpdateSms: "client/pc/wallet/sendChangeLimitationOrderSms",
    //发送钱包
    validateWalletCreditUpdateSms:
        "client/pc/wallet/checkChangeLimitationVerificationCode",
    //自定义编码
    encodeOperation: "client/user/product/operation",
};
